var React = require('react');

function MinusHexagon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M553.48 231.8l-112-192A48.11 48.11 0 0 0 400 16H176a48.11 48.11 0 0 0-41.5 23.8l-112 192a48.19 48.19 0 0 0 0 48.4l112 192A48.11 48.11 0 0 0 176 496h224a48.11 48.11 0 0 0 41.5-23.8l112-192a48.12 48.12 0 0 0 0-48.4zM432 284a12 12 0 0 1-12 12H156a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M432 228v56a12 12 0 0 1-12 12H156a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h264a12 12 0 0 1 12 12z","className":"fa-primary","key":2})]);
}

MinusHexagon.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = MinusHexagon;

MinusHexagon.default = MinusHexagon;
